import { Injectable } from "@angular/core";
import { AppConfig } from "../configs/app";
import { CommonService } from "../services/common.service";
import { CacheService } from "../services/cache.service";

@Injectable({
  providedIn: "root",
})
export class PlanService {
  public moment: any;
  public _: any;

  constructor(
    public appConfig: AppConfig,
    public commonService: CommonService,
    public cacheService: CacheService
  ) {
    this.moment = this.commonService.getMoment();
    this._ = this.commonService.getLodash();
  }

  async getStation(searchParams: any) {
    let returnData = {};

    /* CHECK CACHE */
    let searchParamCacheKey = `${
      this.appConfig.plan.getStationSessionName
    }_${JSON.stringify(searchParams)}`;
    let stationData = this.cacheService.getData(
      searchParamCacheKey,
      this.appConfig.cache.ttl.common
    );
    if (!this._.isEmpty(stationData)) {
      return stationData;
    }

    let requestParams = {};
    if (window.location.href == (window.location.origin + '/sites/map/' + searchParams.travelID + '/' + searchParams.stationID + '/d')) {
      requestParams = {
        travel_id: searchParams.travelID,
        station_id: searchParams.stationID,
        type: 'd',
      }
    } else {
      requestParams = {
        travel_id: searchParams.travelID,
        station_id: searchParams.stationID,
      }
    }

    let params = {
      url: this.appConfig.busAPIBaseURL + "reserve/getStation",
      options: {
        headers: this.commonService.getHTTPBusHeader(),
        // params: {
        //   travel_id: searchParams.travelID,
        //   station_id: searchParams.stationID,
        // },
        params: requestParams,
      },
    };

    let returnedData = await this.commonService.sendHTTPGet(params);

    if (returnedData.status == "success") {
      returnData = returnedData.data;

      /* SAVE CACHE */
      this.cacheService.setData(searchParamCacheKey, returnData);
    } else {
      console.log(returnedData.message);
    }

    return returnData;
  }

  getBestPrice(searchParams: any, callback: any) {
    let returnData = {};

    let searchParamCacheKey = `${
      this.appConfig.plan.bestPriceSessionName
    }_${JSON.stringify(searchParams)}`;

    /* CHECK CACHE */
    let bestPriceData = this.cacheService.getData(
      searchParamCacheKey,
      this.appConfig.cache.ttl.bestPrice
    );
    if (!this._.isEmpty(bestPriceData)) {
      callback(bestPriceData);
    } else {
      let params = {
        url: this.appConfig.busAPIBaseURL + "reserve/getBestPrice",
        options: {
          headers: this.commonService.getHTTPBusHeader(),
          params: {
            dpt_ym: searchParams.departureYMs,
            dpt_coty_id: searchParams.departureID,
            dst_coty_id: searchParams.destinationIDs,
          },
        },
      };

      this.commonService.sendHTTPGetSync(params, (returnedData: any) => {
        if (returnedData.status == "success") {
          returnData = returnedData.data;

          /* SAVE CACHE */
          this.cacheService.setData(searchParamCacheKey, returnData);

          callback(returnData);
        } else {
          console.log(returnedData.message);
          callback(returnData);
        }
      });
    }
  }

  async getPlanList(searchParams: any) {
    if (searchParams.office == null) {
      searchParams.office = "";
    }

    let returnData = {
      list: [],
      price_calendar: {},
      totalPlans: 0,
    };

    let params = {
      url: this.appConfig.busAPIBaseURL + "reserve/getPlanList",
      options: {
        headers: this.commonService.getHTTPBusHeader(),
        params: {
          dpt_ymd: searchParams.departureYMD,
          dpt_coty_id: searchParams.departureCityID,
          dst_coty_id: searchParams.destinationCityID,
          dpt_town_id: searchParams.departureTownID,
          dst_town_id: searchParams.destinationTownID,
          adult: 1,
          plan_flgs_arr: searchParams.planOptions,
          offset: searchParams.offset,
          limit: searchParams.limit,
          sort: searchParams.sort,
          vacancy_only: 0,
          price_calendar: 1,
          office_id: searchParams.office,
        },
      },
    };

    let returnedData = await this.commonService.sendHTTPGet(params);

    if (returnedData.status == "success") {
      returnData.list = returnedData.data.plan_list;
      returnData.price_calendar = returnedData.data.price_calendar;
      returnData.totalPlans = returnedData.data.all_plan_count;
    } else {
      console.log(returnedData.message);
    }

    return returnData;
  }

  async getPlanDetail(planCode: any, targetDay: any = "", viewType: any = "") {
    let params = {
      url: this.appConfig.busAPIBaseURL + "reserve/getPlanDetail",
      options: {
        headers: this.commonService.getHTTPBusHeader(),
        params: {
          plan_code: planCode,
          target_day: targetDay,
          view_type: viewType,
        },
      },
    };

    let returnData = await this.commonService.sendHTTPGet(params);

    if (returnData.status == "success") {
      return !this._.isEmpty(returnData.data) &&
        returnData.data.plan_info_list.length !== 0
        ? returnData.data.plan_info_list[0]
        : {};
    } else {
      console.log(returnData.message);
      return {};
    }
  }

  async getKeioFareData(inputs: any = {}) {
    let params = {
      url: this.appConfig.busAPIBaseURL + "reserve/keioFareData",
      options: {
        headers: this.commonService.getHTTPBusHeader(),
        params: inputs,
      },
    };

    let returnData = await this.commonService.sendHTTPGet(params);

    if (returnData.status == "success") {
      return returnData.data;
    } else {
      console.log(returnData.message);
      return [];
    }
  }

  async getKoboFareData(inputs: any = {}) {
    let params = {
      url: this.appConfig.busAPIBaseURL + "reserve/getPlanPrice",
      options: {
        headers: this.commonService.getHTTPBusHeader(),
        params: inputs,
      },
    };

    let returnData = await this.commonService.sendHTTPGet(params);

    if (returnData.status == "success") {
      return returnData.data;
    } else {
      console.log(returnData.message);
      return {};
    }
  }

  async getDivisions() {
    let returnData = {
      divisions: {},
    };

    /* CHECK CACHE */
    let divisionData = this.cacheService.getData(
      this.appConfig.plan.divisionDataSessionName,
      this.appConfig.cache.ttl.divisionData
    );
    if (!this._.isEmpty(divisionData)) {
      return divisionData;
    }

    let params = {
      url: this.appConfig.busAPIBaseURL + "division/getDivisionForSearch",
      options: {
        headers: this.commonService.getHTTPBusHeader(),
        params: {},
      },
    };

    let returnedData = await this.commonService.sendHTTPGet(params);

    if (returnedData.status == "success") {
      returnData = returnedData.data;

      /* SAVE CACHE */
      this.cacheService.setData(
        this.appConfig.plan.divisionDataSessionName,
        returnData
      );
    } else {
      console.log(returnedData.message);
    }

    return returnData;
  }

  async getTowns(cityID: any) {
    let returnData = {
      divisions: {},
    };

    let params = {
      url: this.appConfig.busAPIBaseURL + "reserve/getTown",
      options: {
        headers: this.commonService.getHTTPBusHeader(),
        params: {
          coty_id: cityID,
        },
      },
    };

    let returnedData = await this.commonService.sendHTTPGet(params);

    if (returnedData.status == "success") {
      /* INSERT INTO FIRST */
      returnedData.data.list.unshift({
        id: "",
        name: "---",
        slug: "",
      });

      returnData = returnedData.data;
    } else {
      console.log(returnedData.message);
    }

    return returnData;
  }

  getPlanOptions() {
    return {
      headings: ["シートタイプ", "設備・サービス"],
      options: {
        シートタイプ: [
          { code: "10101", name: "4列シート" },
          { code: "10102", name: "4列ゆったりシート" },
          { code: "10104", name: "3列（独立）シート" },
          { code: "10105", name: "3列（2+1）シート" },
        ],
        "設備・サービス": [
          { code: "10404", name: "座席指定" },
          { code: "10207", name: "乗務員1名運行" },
          { code: "10206", name: "乗務員2名運行" },
          { code: "10201", name: "ゆったり（のびのび）" },
          { code: "10309", name: "２席利用" },
          { code: "10308", name: "男性不可" },
          { code: "10401", name: "ブランケット" },
          { code: "10307", name: "男性専用" },
          { code: "10304", name: "女性安心" },
          { code: "10303", name: "女性専用" },
          { code: "10306", name: "女性専用車" },
          { code: "10305", name: "女性専用席" },
          { code: "10202", name: "トイレ付き" },
          { code: "10204", name: "コンセント" },
          { code: "10205", name: "無線LAN" },
          { code: "10402", name: "女性コスメ付き" },
          { code: "10402", name: "快適グッズ" },
          { code: "10402", name: "特典付き" },
          /* EXTRAS */
          { code: "10409", name: "小人料金あり" },
        ],
      },
    };
  }

  checkIfHasMenOrWomenOnly(plan: any) {
    plan.menOnly = false;
    plan.womenOnly = false;

    let menOptions = ["10307"];
    let womenOptions = ["10303", "10305", "10308"];

    for (let item of plan.plan_flgs_arr) {
      if (menOptions.indexOf(item.code) !== -1) {
        plan.menOnly = true;
        break;
      } else if (womenOptions.indexOf(item.code) !== -1) {
        plan.womenOnly = true;
        break;
      }
    }
  }

  getCalendarPrices(calendarData: any) {
    let returnData = {};

    if (calendarData) {
      for (let key in calendarData) {
        returnData[key] = {
          min_price: calendarData[key].price,
          price_child: calendarData[key].price_child,
          last_seat: calendarData[key].last_seat,
        };
      }
    }

    return returnData;
  }

  calculateTotal(cartItem: any) {
    /* CHECK IF IT'S KEIO BUS FIRST */
    if (
      cartItem.plan.source_id == this.commonService.appConfig.plan.sources.keio
    ) {
      if (this.checkAvailableKeioBusStations(cartItem)) {
        this.calculateKeioPrice(cartItem);
      } else {
        return false;
      }
    }

    /* PARSE NUMBERS */
    cartItem.passenger.adult.men = parseInt(cartItem.passenger.adult.men);
    cartItem.passenger.adult.women = parseInt(cartItem.passenger.adult.women);
    cartItem.passenger.children.men = parseInt(cartItem.passenger.children.men);
    cartItem.passenger.children.women = parseInt(
      cartItem.passenger.children.women
    );
    /* END */

    let price = cartItem.plan.price;
    let childPrice = cartItem.plan.price_child;

    let total = cartItem.passenger.adult.men * price;
    total += cartItem.passenger.adult.women * price;
    total += cartItem.passenger.children.men * childPrice;
    total += cartItem.passenger.children.women * childPrice;

    cartItem.totalPrice = total;
    cartItem.passenger.adult.total =
      cartItem.passenger.adult.men + cartItem.passenger.adult.women;
    cartItem.passenger.children.total =
      cartItem.passenger.children.men + cartItem.passenger.children.women;
  }

  /* BELONGS TO KEIO BUS */
  checkAvailableKeioBusStations(cartItem: any) {
    if (cartItem.departure != -1 && cartItem.destination != -1) {
      if (cartItem.plan.keio_data.up_down_type == 1) {
        for (let item of cartItem.keioFareData) {
          if (
            item.stationID ==
              cartItem.plan.station_list[cartItem.departure].keio_id &&
            item[cartItem.plan.station_list[cartItem.destination].keio_id]
          ) {
            return true;
          }
        }
      } else {
        for (let item of cartItem.keioFareData) {
          if (
            item.stationID ==
              cartItem.plan.station_list[cartItem.destination].keio_id &&
            item[cartItem.plan.station_list[cartItem.departure].keio_id]
          ) {
            return true;
          }
        }
      }

      /* NOT IN FARE TABLE */
      cartItem.departure = -1;
      cartItem.destination = -1;

      cartItem.plan.price = 0;
      cartItem.plan.price_child = 0;
      cartItem.plan.child_price = 0;
      cartItem.totalPrice = 0;
    }

    return false;
  }

  calculateKeioPrice(cartItem: any) {
    if (cartItem.departure != -1 && cartItem.destination != -1) {
      if (cartItem.plan.keio_data.up_down_type == 1) {
        for (let item of cartItem.keioFareData) {
          if (
            item.stationID ==
              cartItem.plan.station_list[cartItem.departure].keio_id &&
            item[cartItem.plan.station_list[cartItem.destination].keio_id]
          ) {
            if (item.planPersonType == 0) {
              cartItem.plan.price = parseFloat(
                item[cartItem.plan.station_list[cartItem.destination].keio_id]
              );
            } else if (item.planPersonType == 1) {
              cartItem.plan.price_child = parseFloat(
                item[cartItem.plan.station_list[cartItem.destination].keio_id]
              );
              cartItem.plan.child_price = cartItem.plan.price_child;
            }
          }
        }
      } else {
        for (let item of cartItem.keioFareData) {
          if (
            item.stationID ==
              cartItem.plan.station_list[cartItem.destination].keio_id &&
            item[cartItem.plan.station_list[cartItem.departure].keio_id]
          ) {
            if (item.planPersonType == 0) {
              cartItem.plan.price = parseFloat(
                item[cartItem.plan.station_list[cartItem.departure].keio_id]
              );
            } else if (item.planPersonType == 1) {
              cartItem.plan.price_child = parseFloat(
                item[cartItem.plan.station_list[cartItem.departure].keio_id]
              );
              cartItem.plan.child_price = cartItem.plan.price_child;
            }
          }
        }
      }
    }
  }
  /* END OF KEIO BUS */

  /* VIEWED PLANS */
  getViewedPlans(): any {
    let returnData = this.commonService.getData(
      this.appConfig.plan.viewedPlanSessionName
    );
    /* SORT BY UPDATED DATE */
    if (returnData && !this._.isEmpty(returnData.list)) {
      returnData.list.sort(function (item1: any, item2: any) {
        return item2.updatedDate - item1.updatedDate;
      });
    }

    return returnData;
  }

  setPlanViewed(plan: any) {
    if (plan.hasOwnProperty("plan_code")) {
      let now = new Date().getTime();
      let obj = plan;
      /* SET DATE TIME FOR SORTING */
      obj.updatedDate = now;

      let viewedPlans: any = this.commonService.getData(
        this.appConfig.plan.viewedPlanSessionName
      );

      if (viewedPlans) {
      } else {
        viewedPlans = {
          keyMap: {},
          list: [],
        };
      }

      if (viewedPlans.list.length > this.appConfig.plan.maxViewedPlans) {
        let firstPlan = viewedPlans.list[0];
        delete viewedPlans.keyMap[firstPlan.plan_code];
        viewedPlans.list.shift();
      }

      if (!viewedPlans.keyMap.hasOwnProperty(plan.plan_code)) {
        viewedPlans.list.push(obj);
      } else {
        for (let item of viewedPlans.list) {
          if (item.plan_code == plan.plan_code) {
            item.enable_seat = plan.enable_seat;
            item.updatedDate = now;

            break;
          }
        }
      }

      viewedPlans.keyMap[plan.plan_code] = now;

      this.commonService.setData(
        this.appConfig.plan.viewedPlanSessionName,
        viewedPlans
      );
    }
  }

  savePlanViewedData(data: any) {
    this.commonService.setData(this.appConfig.plan.viewedPlanSessionName, data);
  }
  /* END */

  /* FAVOURITE PLANS */
  getFavouritePlans(): any {
    let returnData = this.commonService.getData(
      this.appConfig.plan.favouritePlanSessionName
    );
    /* SORT BY UPDATED DATE */
    if (returnData && !this._.isEmpty(returnData.list)) {
      returnData.list.sort(function (item1: any, item2: any) {
        return item2.updatedDate - item1.updatedDate;
      });
    }

    return returnData;
  }

  setPlanFavourite(plan: any) {
    if (plan.hasOwnProperty("plan_code")) {
      let obj = plan;

      let favouritePlans: any = this.commonService.getData(
        this.appConfig.plan.favouritePlanSessionName
      );

      if (favouritePlans) {
      } else {
        favouritePlans = {
          keyMap: {},
          list: [],
        };
      }

      /* SET / UNSET */
      if (!favouritePlans.keyMap.hasOwnProperty(plan.plan_code)) {
        favouritePlans.keyMap[plan.plan_code] = new Date().getTime();
        favouritePlans.list.push(obj);
      } else {
        delete favouritePlans.keyMap[obj.plan_code];
        for (let i = 0; i < favouritePlans.list.length; i++) {
          if (favouritePlans.list[i].plan_code == obj.plan_code) {
            favouritePlans.list.splice(i, 1);
            break;
          }
        }
      }

      this.commonService.setData(
        this.appConfig.plan.favouritePlanSessionName,
        favouritePlans
      );
    }
  }
  /* END */

  getViewedTimePlan(planCode, viewedPlans) {
    if (viewedPlans) {
    } else {
      viewedPlans = this.getViewedPlans();
    }

    if (viewedPlans && viewedPlans.keyMap.hasOwnProperty(planCode)) {
      let days = this.moment().diff(
        this.moment(viewedPlans.keyMap[planCode]),
        "days"
      );
      if (days !== 0) {
        return `閲覧済み ${days}日前`;
      } else {
        return `閲覧済み`;
      }
    }

    return "";
  }

  getMIcon(code: string) {
    return this.appConfig.plan.mIcons[code]
      ? this.appConfig.plan.mIcons[code]
      : code;
  }

  /* FOR FILTER */
  saveFilterOptions(data: any) {
    this.commonService.setData(this.appConfig.plan.filterSessionName, data);
  }

  getFilterOptions(): any {
    return this.commonService.getData(this.appConfig.plan.filterSessionName);
  }
}
